import { createRoot } from 'react-dom/client';
import App from './App';
import { bootstrap } from './bootstrap';
import { loadRuntimeConfig } from './utils/runtimeConfig';
import { primeViewScopeSnapshot } from './utils/viewScope';

const container = document.getElementById('root');
if (!container) {
  throw new Error('找不到 #root 元素');
}

void bootstrap({
  initialize: loadRuntimeConfig,
  // 讓 authFetch（React 樹外）在第一個請求前就有正確的檢視範圍值。
  prime: primeViewScopeSnapshot,
  render: () => createRoot(container).render(<App />),
  showConfigurationError: () => {
    container.textContent =
      '無法載入 BO 設定，請確認 /config/bo-web.json 後重新整理頁面。';
  },
});
